import moment from "moment";

export const validateLicenceDate = (birthday, licence) => {
    const birthDate = moment(
        birthday,
        "DD/MM/YYYY",
        true
    );

    const licenceDate = moment(
        licence,
        "DD/MM/YYYY",
        true
    );
    
    if (!licenceDate.isValid()) {
        return false;
    }

    const minimumLicenceDate = birthDate
        .clone()
        .add(18, "years");

    const isAfterEighteen = licenceDate.isSameOrAfter(
        minimumLicenceDate,
        "day"
    );

    const isNotFutureDate = licenceDate.isSameOrBefore(
        moment(),
        "day"
    );

    if (birthDate.isValid()){
        return isAfterEighteen && isNotFutureDate;
    }

    return isNotFutureDate;
};